import {
  AddTrainingPayload,
  EditTrainingPayload,
} from "../../../../models/Training";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allTrainingKey } from "../../queries/Training/useFetchAllTraining";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function editTraining(data: EditTrainingPayload) {
  const res = await ApiClient.put(`/EditTraining`, data);
  return res.data;
}

export const useEditTraining = mutationWrapper(editTraining, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allTrainingKey);
  },
});
